class HourlyProducts extends HTMLElement {
  constructor() {
    super();

    this.hourlyInterval = parseInt(this.getAttribute("data-interval"));
    this.dailyInterval = parseInt(this.getAttribute("data-interval-day"));
		this.intervalBase = this.getAttribute("data-interval-base");
    this.sectionId = this.getAttribute("data-section-id");
    this.collectionhandle = this.getAttribute("data-collection-handle");
    this.productHandles = (this.getAttribute("data-product-handles") || "").trim().split(",").filter(Boolean);
		this.colCountMobile = Number(this.getAttribute('data-products-per-row-mobile')) || 2;
		this.colCountDesktop = Number(this.getAttribute('data-products-per-row-desktop')) || 5;
  }

  getPageNumbHourly(hour, times) {
    return Math.ceil((hour + 1) / times);
  }

  getPageNumbDaily(day, times) {
    return Math.ceil(day / times);
  }

  calculatePageNumb() {
    var nowDate = new Date();
    this.pageNumb = this.intervalBase === "day"
			? this.getPageNumbDaily(nowDate.getDate(), this.dailyInterval)
			: this.getPageNumbHourly(nowDate.getHours(), this.hourlyInterval);

		/* never more than page 4, as agreed to with merchant... */
    if (this.pageNumb > 4) {
      this.pageNumb = this.pageNumb % 4;

      /* deal with e.g. page 8 being == 0, as we do modulo on it... let's not request page 0 :D */
      if (this.pageNumb == 0) {
        this.pageNumb = 4;
      }
    }
  }

  renderRes(resJSON) {
    this.domParser = new DOMParser();
    this.sectionRawHTML = this.domParser.parseFromString(
      resJSON[this.sectionId],
      "text/html"
    );

    this.innerHTML = this.sectionRawHTML.querySelector(".shopify-section").innerHTML;
		const cardEls = this.querySelectorAll(".productcard--xs");

		if (this.colCountMobile !== 2) {
			cardEls.forEach(cardEl => {
				cardEl.classList.remove("fi:1/2");
				cardEl.classList.add(`fi:1/${this.colCountMobile}`);
			});
		}

		if (this.colCountDesktop !== 5) {
			cardEls.forEach(cardEl => {
				cardEl.classList.remove("md-up:fi:1/5");
				cardEl.classList.add(`md-up:fi:1/${this.colCountDesktop}`);
			});
		}

    this.registerExpandBtn();
  }

  registerExpandBtn() {
    this.expandBtn = this.querySelector('button[name="expand"]');
    this.expandBtn.addEventListener('click', this.expandProducts.bind(this));
  }

  expandProducts() {
    this.expandBtn.removeEventListener('click', this.expandProducts);
    this.btnContainer = this.querySelector('[data-btn-expander]');
    this.btnContainer.remove();

    this.classList.add('expanded');
  }

  connectedCallback() {
    this.calculatePageNumb();

		this.requestURL = new URL(window.location.href);
		this.requestURL.searchParams.set("sections", this.sectionId);
		if (this.productHandles.length) {
			let baseChunkSize = Math.ceil(this.productHandles.length / 4);
			const maxReturnedProducts = this.productHandles.length;
			let minReturnedProducts = this.colCountDesktop * 2;
			if (minReturnedProducts > maxReturnedProducts) {
				minReturnedProducts = maxReturnedProducts;
			}

			if (baseChunkSize < minReturnedProducts) {
				baseChunkSize = minReturnedProducts;
			}

			baseChunkSize = Math.ceil(baseChunkSize / (minReturnedProducts)) * (minReturnedProducts);

			const chunkIndex = (this.pageNumb - 1) % 4;

			let start = chunkIndex * baseChunkSize;
			let end = start + baseChunkSize;

			if (start >= this.productHandles.length) {
				start = 0;
				end = baseChunkSize;
			}

			let productHandles = [];
			if (end > this.productHandles.length) {
				const overflow = end - this.productHandles.length;
				const main = this.productHandles.slice(start);
				const remainder = this.productHandles.slice(0, overflow);
				productHandles = main.concat(remainder);
			} else {
				productHandles = this.productHandles.slice(start, end);
			}

			this.requestURL.pathname = "/search";
			this.requestURL.searchParams.set("q", productHandles.join(","));
		} else {
			this.requestURL.pathname = "/collections/" + this.collectionhandle;
			this.requestURL.searchParams.set("page", this.pageNumb);
		}

    fetch(this.requestURL.toString())
      .then((res) => res.json())
      .then((resJSON) => {
        this.renderRes(resJSON);
				if (!this.productHandles.length) {
					const desktopColSize = this.colCountDesktop;
					const returnedProducts = this.querySelectorAll("[data-async-item]");
					const productsToRemove = returnedProducts.length % desktopColSize;
					for (let i = 0; i < productsToRemove; i++) {
						returnedProducts[returnedProducts.length - 1 - i].classList.add("md-up:hidden");
					}
				}
      })
      .catch((err) => console.warn(err));
  }
}

customElements.define("hourly-products", HourlyProducts);
